export const BUSINESS_UNIT_OPTIONS = [
  { value: "10272669", label: "Amazon, Global Mile" },
  { value: "10272671", label: "Amazon, Middle Mile EU" },
  { value: "10272672", label: "Amazon, India Cargo" },
  { value: "10272673", label: "Amazon, Freight EU" },
  { value: "10272674", label: "Amazon, Freight External (AFE)" },
  { value: "10272675", label: "Amazon, AWS" },
  { value: "10273528", label: "Amazon, Devices Global Logistics" },
  { value: "10273679", label: "Amazon, Supply Chain Loss Prevention" },
  { value: "10273707", label: "Global China" },
  { value: "10273708", label: "Global Mexico" },
  { value: "10273709", label: "Amazon, GL EU Imports" },
  { value: "10276123", label: "Amazon, Middle Mile NA" },
  { value: "10277179", label: "Amazon, EERO" },
  { value: "10281529", label: "Amazon, Robotics" },
  { value: "10281737", label: "Amazon, Freight Internal (AFI)" },
  { value: "10281827", label: "Amazon, Warehousing and Distribution" },
  { value: "10282823", label: "Amazon, Transportation IT" },
  { value: "10286762", label: "Amazon, Vendor Services - Retail" },
  { value: "10287297", label: "Amazon, Kuiper" },
  { value: "10292958", label: "Amazon, Air Cargo" },
  { value: "10294721", label: "Amazon, First Mile" },
  { value: "10296461", label: "Amazon, Zoox" },
  { value: "10297165", label: "Amazon, WePau EU" },
];

export const VERTICAL_OPTIONS = [
  { value: "1", label: "SCLP – ST IB (Surface Transportation Inbound)" },
  { value: "2", label: "SCLP – ST TS (Surface Transportation Transship)" },
  { value: "3", label: "SCLP – ST Rail (Surface Transportation Rail)" },
  { value: "4", label: "SCLP – ST OB (Surface Transportation Outbound)" },
  { value: "5", label: "SCLP – GM Dray (Global Mile Dray)" },
  { value: "6", label: "SCLP – GM Ocean (Global Mile Ocean)" },
  { value: "7", label: "SCLP – GM 3P (Global Mile 3P Sites)" },
];

export const CLAIM_TYPE_OPTIONS = [
  { value: "5", label: "Damaged Cargo" },
  { value: "47", label: "Missing Cargo" },
  { value: "111", label: "Damaged & Missing Cargo" },
  { value: "129", label: "Property Damage" },
];

export const COUNTRY_OPTIONS = [
  { value: "6", label: "AFGHANISTAN" },
  { value: "7", label: "ALGERIA" },
  { value: "8", label: "ANGOLA" },
  { value: "9", label: "AZORES (PORTUGAL)" },
  { value: "10", label: "ARGENTINA" },
  { value: "11", label: "AUSTRIA" },
  { value: "12", label: "AUSTRALIA" },
  { value: "13", label: "AZERBAIJAN" },
  { value: "14", label: "BANGLADESH" },
  { value: "15", label: "BARBADOS" },
  { value: "16", label: "BELGIUM" },
  { value: "17", label: "BULGARIA" },
  { value: "18", label: "BAHRAIN" },
  { value: "19", label: "BENIN" },
  { value: "20", label: "BURKINA FASO" },
  { value: "21", label: "BELIZE" },
  { value: "22", label: "BERMUDA" },
  { value: "23", label: "BRUNEI" },
  { value: "24", label: "BOTSWANA" },
  { value: "25", label: "BRAZIL" },
  { value: "26", label: "BAHAMAS" },
  { value: "27", label: "BURMA - NOW MYANMAR" },
  { value: "28", label: "BOLIVIA" },
  { value: "29", label: "CANADA" },
  { value: "30", label: "CAMBODIA" },
  { value: "31", label: "CONGO DEMOCRATIC REPUBLIC" },
  { value: "32", label: "CHINA" },
  { value: "33", label: "CAYMAN ISLANDS" },
  { value: "34", label: "CHILE" },
  { value: "35", label: "CAMEROON" },
  { value: "36", label: "CONGO REPUBLIC" },
  { value: "37", label: "COLOMBIA" },
  { value: "38", label: "CAPE VERDE ISLANDS" },
  { value: "39", label: "COSTA RICA" },
  { value: "40", label: "CROATIA" },
  { value: "41", label: "CUBA" },
  { value: "42", label: "CYPRUS (SOUTH)" },
  { value: "43", label: "CZECH REPUBLIC" },
  { value: "44", label: "DENMARK" },
  { value: "45", label: "DJIBOUTI" },
  { value: "46", label: "ECUADOR" },
  { value: "47", label: "ETHIOPIA" },
  { value: "48", label: "IRELAND, REPUBLIC OF" },
  { value: "49", label: "ESTONIA" },
  { value: "50", label: "ERITREA" },
  { value: "51", label: "EL SALVADOR" },
  { value: "52", label: "EGYPT" },
  { value: "53", label: "FAROE ISLANDS" },
  { value: "54", label: "FRENCH GUIANA" },
  { value: "55", label: "FINLAND" },
  { value: "56", label: "FIJI" },
  { value: "57", label: "FALKLAND ISLANDS" },
  { value: "58", label: "FRANCE" },
  { value: "59", label: "GAMBIA" },
  { value: "60", label: "GABON" },
  { value: "61", label: "GERMANY" },
  { value: "62", label: "GHANA" },
  { value: "63", label: "GIBRALTAR" },
  { value: "64", label: "GUINEA-BISSAU" },
  { value: "65", label: "GEORGIA" },
  { value: "66", label: "GREECE" },
  { value: "67", label: "GUATEMALA" },
  { value: "68", label: "GUYANA" },
  { value: "69", label: "HAITI" },
  { value: "70", label: "HONG KONG" },
  { value: "71", label: "HONDURAS" },
  { value: "72", label: "HUNGARY" },
  { value: "73", label: "IRAN" },
  { value: "74", label: "ICELAND" },
  { value: "75", label: "INDONESIA" },
  { value: "76", label: "INDIA" },
  { value: "77", label: "IRAQ" },
  { value: "78", label: "ISRAEL" },
  { value: "79", label: "ITALY" },
  { value: "80", label: "IVORY COAST" },
  { value: "81", label: "JAPAN" },
  { value: "82", label: "JAMAICA" },
  { value: "83", label: "JORDAN" },
  { value: "84", label: "KAZAKHSTAN" },
  { value: "85", label: "KENYA" },
  { value: "86", label: "KOREA (NORTH)" },
  { value: "87", label: "KOREA (SOUTH)" },
  { value: "88", label: "KUWAIT" },
  { value: "89", label: "LATVIA" },
  { value: "90", label: "LEBANON" },
  { value: "91", label: "LIBERIA" },
  { value: "92", label: "LIECHTENSTEIN" },
  { value: "93", label: "LITHUANIA" },
  { value: "94", label: "LUXEMBOURG" },
  { value: "95", label: "LIBYA" },
  { value: "96", label: "MALAWI" },
  { value: "97", label: "MALDIVES" },
  { value: "98", label: "MEXICO" },
  { value: "99", label: "MADAGASCAR" },
  { value: "100", label: "MAURITIUS" },
  { value: "101", label: "MALAYSIA" },
  { value: "102", label: "MARIANA ISLANDS" },
  { value: "103", label: "MOZAMBIQUE" },
  { value: "104", label: "MOROCCO" },
  { value: "105", label: "MALTA" },
  { value: "106", label: "MAURITANIA" },
  { value: "107", label: "MYANMAR" },
  { value: "108", label: "CURACAO" },
  { value: "109", label: "NEW CALEDONIA" },
  { value: "110", label: "NETHERLANDS" },
  { value: "111", label: "NORFOLK ISLAND" },
  { value: "112", label: "PAPUA NEW GUINEA" },
  { value: "113", label: "NIGERIA" },
  { value: "114", label: "NAMIBIA" },
  { value: "115", label: "NORWAY" },
  { value: "116", label: "NEPAL" },
  { value: "117", label: "NICARAGUA" },
  { value: "118", label: "NIGER" },
  { value: "119", label: "NEW ZEALAND" },
  { value: "120", label: "OMAN" },
  { value: "121", label: "PAKISTAN" },
  { value: "122", label: "PERU" },
  { value: "123", label: "PHILIPPINES" },
  { value: "124", label: "POLAND" },
  { value: "125", label: "PANAMA" },
  { value: "126", label: "PORTUGAL" },
  { value: "127", label: "PARAGUAY" },
  { value: "128", label: "PUERTO RICO" },
  { value: "129", label: "QATAR" },
  { value: "130", label: "REUNION" },
  { value: "131", label: "GUINEA CONAKRY" },
  { value: "132", label: "ROMANIA" },
  { value: "133", label: "RUSSIA" },
  { value: "134", label: "SOUTH AFRICA" },
  { value: "135", label: "ST VINCENT & GRENADINES (WI)" },
  { value: "136", label: "SAUDI ARABIA" },
  { value: "137", label: "SEYCHELLES" },
  { value: "138", label: "SPANISH NORTH AFRICA" },
  { value: "139", label: "SUDAN" },
  { value: "140", label: "ST HELENA" },
  { value: "141", label: "SINGAPORE" },
  { value: "142", label: "SURINAME" },
  { value: "143", label: "SRI LANKA" },
  { value: "144", label: "SAMOA (WESTERN)" },
  { value: "145", label: "SENEGAL" },
  { value: "146", label: "SLOVAKIA" },
  { value: "147", label: "SPAIN" },
  { value: "148", label: "SIERRA LEONE" },
  { value: "149", label: "SWITZERLAND" },
  { value: "150", label: "ST LUCIA (WI)" },
  { value: "151", label: "SLOVENIA" },
  { value: "152", label: "SWEDEN" },
  { value: "153", label: "SYRIA" },
  { value: "154", label: "SWAZILAND" },
  { value: "155", label: "TAIWAN" },
  { value: "156", label: "TONGA (FRIENDLY ISLANDS)" },
  { value: "157", label: "THAILAND" },
  { value: "158", label: "TUNISIA" },
  { value: "159", label: "TOGO" },
  { value: "160", label: "TRINIDAD AND TOBAGO (WI)" },
  { value: "161", label: "TURKEY" },
  { value: "162", label: "TANZANIA" },
  { value: "163", label: "UNITED ARAB EMIRATES" },
  { value: "164", label: "UGANDA" },
  { value: "165", label: "UKRAINE" },
  { value: "166", label: "UNITED KINGDOM" },
  { value: "167", label: "USSR - NO LONGER IN USE" },
  { value: "168", label: "USA" },
  { value: "169", label: "URUGUAY" },
  { value: "170", label: "UZBEKISTAN" },
  { value: "171", label: "VENEZUELA" },
  { value: "172", label: "VIETNAM" },
  { value: "173", label: "YEMEN" },
  { value: "174", label: "SERBIA" },
  { value: "175", label: "ZAIRE ( SEE CONGO DEM.REP)" },
  { value: "176", label: "ZIMBABWE" },
  { value: "177", label: "ZAMBIA" },
  { value: "178", label: "BELARUS" },
  { value: "181", label: "LAOS" },
  { value: "182", label: "DOMINICAN REPUBLIC" },
  { value: "186", label: "MACAU" },
  { value: "187", label: "BOSNIA HERZEGOVINA" },
  { value: "188", label: "NAURU" },
  { value: "189", label: "SOLOMON ISLANDS" },
  { value: "190", label: "VANUATU" },
  { value: "191", label: "BURUNDI" },
  { value: "193", label: "MADEIRA (PORTUGAL)" },
  { value: "194", label: "RWANDA" },
  { value: "195", label: "ANTIGUA & BARBUDA" },
  { value: "198", label: "DOMINICA" },
  { value: "199", label: "GRENADA" },
  { value: "200", label: "GUADELOUPE" },
  { value: "201", label: "MARTINIQUE" },
  { value: "203", label: "ST. KITTS & NEVIS" },
  { value: "204", label: "VIRGIN ISLANDS (US)" },
  { value: "205", label: "VIRGIN ISLANDS (UK)" },
  { value: "206", label: "POLYNESIA (FRENCH)" },
  { value: "207", label: "SAO TOME" },
  { value: "210", label: "SOMALIA" },
  { value: "211", label: "CYPRUS (NORTH)" },
  { value: "212", label: "HOLLAND - SEE NETHERLANDS" },
  { value: "213", label: "GREENLAND" },
  { value: "214", label: "YUGOSLAVIA SEE SERBIA ETC." },
  { value: "215", label: "MALI" },
  { value: "216", label: "MONTENEGRO" },
  { value: "217", label: "ALBANIA" },
  { value: "218", label: "TAJIKISTAN" },
  { value: "219", label: "KYRGYZSTAN" },
  { value: "220", label: "LESOTHO" },
  { value: "221", label: "MACEDONIA" },
  { value: "222", label: "TURKS & CAICOS" },
  { value: "223", label: "GUAM" },
  { value: "224", label: "CANARY ISLANDS (SPAIN)" },
  { value: "226", label: "MOLDOVA" },
  { value: "227", label: "BHUTAN" },
  { value: "231", label: "MONACO" },
  { value: "232", label: "ANDORRA" },
  { value: "233", label: "ARMENIA" },
  { value: "235", label: "CHAD" },
  { value: "236", label: "TURKMENISTAN" },
  { value: "237", label: "ARUBA" },
  { value: "238", label: "GUINEA EQUATORIAL" },
  { value: "239", label: "MARSHALL ISLANDS" },
  { value: "240", label: "MICRONESIA" },
  { value: "241", label: "MONGOLIA" },
  { value: "243", label: "COMOROS" },
  { value: "244", label: "CENTRAL AFRICAN REPUBLIC" },
  { value: "245", label: "FRENCH WEST INDIES" },
  { value: "246", label: "KOSOVO" },
  { value: "247", label: "TIMOR LESTE" },
  { value: "248", label: "SUDAN SOUTH" },
  { value: "249", label: "ANGUILLA" },
  { value: "250", label: "BONAIRE" },
  { value: "251", label: "MONTSERRAT" },
  { value: "252", label: "SAINT BARTHELEMY" },
  { value: "254", label: "SINT MAARTEN" },
  { value: "255", label: "TURKS AND CAICOS ISLANDS" },
  { value: "256", label: "MAYOTTE" },
  { value: "257", label: "PALAU" },
];

export const CARRIER_NAME_OPTIONS = [
  { value: "25", label: "Amazon Freight" },
  { value: "26", label: "Crane" },
  { value: "27", label: "DBS" },
  { value: "28", label: "DHL" },
  { value: "29", label: "K + N" },
  { value: "30", label: "Other - Select Carrier by SCAC code" },
  { value: "31", label: "Other - Type Carrier name" },
];

export const SCAC_CARRIER_OPTIONS = [
  { value: "ACTL", label: "Accord Transportation Ltd" },
  { value: "AMZN", label: "AMZN" },
  { value: "ARNB", label: "Arnold Bros Transport Ltd" },
  { value: "ATBL", label: "Aman truck Lines, LLC." },
  { value: "AXCQ", label: "ATLANTIC" },
  { value: "BIOS", label: "Bison Transport" },
  { value: "BNLS", label: "BNSF Logistics" },
  { value: "CKKI", label: "C&K Trucking, LLC" },
  { value: "CLIJ", label: "Charger Logistics Canada" },
  { value: "CLLQ", label: "Coyote Logistics" },
  { value: "CMFH", label: "Challenger Motor Freight Inc." },
  { value: "CVLG", label: "Caravan Logistics Inc" },
  { value: "ECMR", label: "ECMS GLOBAL" },
  { value: "FHTP", label: "Forbes Hewlett Transportation" },
  { value: "FMEX", label: "FLETES MEXICO CARGA EXPRESS S DE RL DE CV" },
  { value: "GRWI", label: "GILL ROADWAYS INC." },
  { value: "HCWI", label: "JB Hunt - CB" },
  { value: "HHWY", label: "Hub Highway" },
  { value: "HJBA", label: "JB Hunt % Central Transport" },
  { value: "HJBI", label: "JB Hunt Intermodal" },
  { value: "HJBT", label: "JB HUNT" },
  { value: "HJCS", label: "J. B. Hunt" },
  { value: "HNMC", label: "MX Logistics Alliance Inc" },
  { value: "HRTD", label: "Hartt Transportation Systems Inc." },
  { value: "HUBG", label: "Hub Group Intermodal" },
  { value: "JBGM", label: "J.B. Hunt Transportation, Inc." },
  { value: "KNIG", label: "Knight" },
  { value: "KXLN", label: "Kross X Logistics, Inc." },
  { value: "MAEO", label: "Auto Express Oriente" },
  { value: "MXET", label: "METRO EXPRESS LTD" },
  { value: "MXFH", label: "FH LOGISTICA" },
  { value: "NWYD", label: "New-Way Trucking Ltd" },
  { value: "OFTO", label: "AC Transport" },
  { value: "PDIB", label: "Progistics Distribution, LLC" },
  { value: "PGPS", label: "PRIDE GROUP LOGISTICS" },
  { value: "PLYI", label: "PEPSI" },
  { value: "RBTW", label: "CH Robinson Company Inc" },
  { value: "RELAY", label: "All Relay Carriers" },
  { value: "RKNE", label: "RoadOne IntermodaLogistics" },
  { value: "SCDS", label: "Schneider National Intermodal" },
  { value: "SCNN", label: "SCHNEIDER" },
  { value: "SFAH", label: "SF Express" },
  { value: "SFBC", label: "Spartan Freight Systems" },
  { value: "SOLG", label: "SOS Logistics" },
  { value: "SUNB", label: "Sunbury Transport Limited" },
  { value: "SWFT", label: "SWIFT" },
  { value: "SWIF", label: "Swift Intermodal" },
  { value: "SWOA", label: "Swift Logistics" },
  { value: "TEZK", label: "Transnet Freight LTD" },
  { value: "TFIN", label: "TFORCE Freight" },
  { value: "TFXE", label: "673753 Ontario Ltd o/a Traffix" },
  { value: "TNXL", label: "TransX Group of Companies Ltd" },
  { value: "TOMY", label: "Amazon Logistics" },
  { value: "TPGH", label: "Triple Eight Transport Inc." },
  { value: "TPTO", label: "TPT SYSTEMS LTD O/A TRANSPRO FREIGHT SYSTEMS" },
  { value: "TSGD", label: "ISG Direct Inc" },
  { value: "WKTV", label: "Wheel King Transhaul Inc" },
  { value: "WPTA", label: "Western Pacific Transport Ltd" },
  { value: "WWCI", label: "World Wide Carriers" },
  { value: "XPOL", label: "XPO Logistics LLC" },
  { value: "DSGM", label: "DSV" },
];

export const MODE_OF_TRANSPORT_OPTIONS = [
  { value: "Air", label: "Air" },
  { value: "Other", label: "Other" },
  { value: "Rail", label: "Rail" },
  { value: "Truck", label: "Truck" },
  { value: "Vessel", label: "Vessel" },
  { value: "Warehouse", label: "Warehouse" },
];

export const TRAILER_TYPE_TRUCK_OPTIONS = [
  { value: "Full Truckload", label: "Full Truckload" },
  { value: "LTL", label: "LTL" },
];

export const TRAILER_TYPE_RAIL_OPTIONS = [
  { value: "Intermodal", label: "Intermodal" },
];

export const CURRENCY_OPTIONS = [
  { value: "USD", label: "US Dollar" },
  { value: "EUR", label: "Euro" },
  { value: "GBP", label: "Pound Sterling" },
  { value: "AED", label: "UAE Dirham" },
  { value: "AFN", label: "Afghani" },
  { value: "ALL", label: "Lek" },
  { value: "AMD", label: "Armenian Dram" },
  { value: "ANG", label: "Netherlands Antillean Guilder" },
  { value: "AOA", label: "Kwanza" },
  { value: "ARS", label: "Argentine Peso" },
  { value: "AUD", label: "Australian Dollar" },
  { value: "AWG", label: "Aruban Florin" },
  { value: "AZN", label: "Azerbaijanian Manat" },
  { value: "BAM", label: "Convertible Mark" },
  { value: "BBD", label: "Barbados Dollar" },
  { value: "BDT", label: "Taka" },
  { value: "BGN", label: "Bulgarian Lev" },
  { value: "BHD", label: "Bahraini Dinar" },
  { value: "BIF", label: "Burundi Franc" },
  { value: "BMD", label: "Bermudian Dollar" },
  { value: "BND", label: "Brunei Dollar" },
  { value: "BOB", label: "Boliviano" },
  { value: "BOV", label: "Mvdol" },
  { value: "BRL", label: "Brazilian Real" },
  { value: "BSD", label: "Bahamian Dollar" },
  { value: "BTN", label: "Ngultrum" },
  { value: "BWP", label: "Pula" },
  { value: "BYR", label: "Belarussian Ruble" },
  { value: "BZD", label: "Belize Dollar" },
  { value: "CAD", label: "Canadian Dollar" },
  { value: "CDF", label: "Congolese Franc" },
  { value: "CHF", label: "Swiss Franc" },
  { value: "CLF", label: "Unidades de fomento" },
  { value: "CLP", label: "Chilean Peso" },
  { value: "CNY", label: "Yuan Renminbi" },
  { value: "COP", label: "Colombian Peso" },
  { value: "COU", label: "Unidad de Valor Real" },
  { value: "CRC", label: "Costa Rican Colon" },
  { value: "CUC", label: "Peso Convertible" },
  { value: "CUP", label: "Cuban Peso" },
  { value: "CVE", label: "Cape Verde Escudo" },
  { value: "CZK", label: "Czech Koruna" },
  { value: "DJF", label: "Djibouti Franc" },
  { value: "DKK", label: "Danish Krone" },
  { value: "DOP", label: "Dominican Peso" },
  { value: "DZD", label: "Algerian Dinar" },
  { value: "EGP", label: "Egyptian Pound" },
  { value: "ERN", label: "Nakfa" },
  { value: "ETB", label: "Ethiopian Birr" },
  { value: "FJD", label: "Fiji Dollar" },
  { value: "FKP", label: "Falkland Islands Pound" },
  { value: "GEL", label: "Lari" },
  { value: "GHS", label: "Ghana Cedi" },
  { value: "GIP", label: "Gibraltar Pound" },
  { value: "GMD", label: "Dalasi" },
  { value: "GNF", label: "Guinea Franc" },
  { value: "GTQ", label: "Quetzal" },
  { value: "GYD", label: "Guyana Dollar" },
  { value: "HKD", label: "Hong Kong Dollar" },
  { value: "HNL", label: "Lempira" },
  { value: "HRK", label: "Croatian Kuna" },
  { value: "HTG", label: "Gourde" },
  { value: "HUF", label: "Forint" },
  { value: "IDR", label: "Rupiah" },
  { value: "ILS", label: "New Israeli Sheqel" },
  { value: "INR", label: "Indian Rupee" },
  { value: "IQD", label: "Iraqi Dinar" },
  { value: "IRR", label: "Iranian Rial" },
  { value: "ISK", label: "Iceland Krona" },
  { value: "JMD", label: "Jamaican Dollar" },
  { value: "JOD", label: "Jordanian Dinar" },
  { value: "JPY", label: "Yen" },
  { value: "KES", label: "Kenyan Shilling" },
  { value: "KGS", label: "Som" },
  { value: "KHR", label: "Riel" },
  { value: "KMF", label: "Comoro Franc" },
  { value: "KPW", label: "North Korean Won" },
  { value: "KRW", label: "South Korean Won" },
  { value: "KWD", label: "Kuwaiti Dinar" },
  { value: "KYD", label: "Cayman Islands Dollar" },
  { value: "KZT", label: "Tenge" },
  { value: "LAK", label: "Kip" },
  { value: "LBP", label: "Lebanese Pound" },
  { value: "LKR", label: "Sri Lanka Rupee" },
  { value: "LRD", label: "Liberian Dollar" },
  { value: "LSL", label: "Loti" },
  { value: "LTL", label: "Lithuanian Litas" },
  { value: "LVL", label: "Latvian Lats" },
  { value: "LYD", label: "Libyan Dinar" },
  { value: "MAD", label: "Moroccan Dirham" },
  { value: "MDL", label: "Moldovan Leu" },
  { value: "MGA", label: "Malagasy Ariary" },
  { value: "MKD", label: "Denar" },
  { value: "MMK", label: "Kyat" },
  { value: "MNT", label: "Tugrik" },
  { value: "MOP", label: "Pataca" },
  { value: "MRO", label: "Ouguiya" },
  { value: "MUR", label: "Mauritius Rupee" },
  { value: "MVR", label: "Rufiyaa" },
  { value: "MWK", label: "Kwacha" },
  { value: "MXN", label: "Mexican Peso" },
  { value: "MXV", label: "Mexican Unidad de Inversion (UDI)" },
  { value: "MYR", label: "Malaysian Ringgit" },
  { value: "MZN", label: "Mozambique Metical" },
  { value: "NAD", label: "Namibia Dollar" },
  { value: "NGN", label: "Naira" },
  { value: "NIO", label: "Cordoba Oro" },
  { value: "NOK", label: "Norwegian Krone" },
  { value: "NPR", label: "Nepalese Rupee" },
  { value: "NZD", label: "New Zealand Dollar" },
  { value: "OMR", label: "Rial Omani" },
  { value: "PAB", label: "Balboa" },
  { value: "PEN", label: "Nuevo Sol" },
  { value: "PGK", label: "Kina" },
  { value: "PHP", label: "Philippine Peso" },
  { value: "PKR", label: "Pakistan Rupee" },
  { value: "PLN", label: "Zloty" },
  { value: "PYG", label: "Guarani" },
  { value: "QAR", label: "Qatari Rial" },
  { value: "RON", label: "New Romanian Leu" },
  { value: "RSD", label: "Serbian Dinar" },
  { value: "RUB", label: "Russian Ruble" },
  { value: "RWF", label: "Rwanda Franc" },
  { value: "SAR", label: "Saudi Riyal" },
  { value: "SBD", label: "Solomon Islands Dollar" },
  { value: "SCR", label: "Seychelles Rupee" },
  { value: "SDG", label: "Sudanese Pound" },
  { value: "SEK", label: "Swedish Krona" },
  { value: "SGD", label: "Singapore Dollar" },
  { value: "SHP", label: "Saint Helena Pound" },
  { value: "SLL", label: "Leone" },
  { value: "SOS", label: "Somali Shilling" },
  { value: "SRD", label: "Surinam Dollar" },
  { value: "SSP", label: "South Sudanese Pound" },
  { value: "STD", label: "Dobra" },
  { value: "SVC", label: "El Salvador Colon" },
  { value: "SYP", label: "Syrian Pound" },
  { value: "SZL", label: "Lilangeni" },
  { value: "THB", label: "Baht" },
  { value: "TJS", label: "Somoni" },
  { value: "TMT", label: "Turkmenistan New Manat" },
  { value: "TND", label: "Tunisian Dinar" },
  { value: "TOP", label: "Pa'anga" },
  { value: "TRY", label: "Turkish Lira" },
  { value: "TTD", label: "Trinidad and Tobago Dollar" },
  { value: "TWD", label: "New Taiwan Dollar" },
  { value: "TZS", label: "Tanzanian Shilling" },
  { value: "UAH", label: "Hryvnia" },
  { value: "UGX", label: "Uganda Shilling" },
  { value: "UYU", label: "Peso Uruguayo" },
  { value: "UZS", label: "Uzbekistan Sum" },
  { value: "VEF", label: "Bolivar" },
  { value: "VND", label: "Dong" },
  { value: "VUV", label: "Vatu" },
  { value: "WST", label: "Tala" },
  { value: "XAF", label: "CFA Franc BEAC" },
  { value: "XCD", label: "East Caribbean Dollar" },
  { value: "XFU", label: "UIC-Franc" },
  { value: "XOF", label: "CFA Franc BCEAO" },
  { value: "XPF", label: "CFP Franc" },
  { value: "YER", label: "Yemeni Rial" },
  { value: "ZAR", label: "Rand" },
  { value: "ZMK", label: "Zambian Kwacha" },
  { value: "ZWL", label: "Zimbabwe Dollar" },
];

export const HANDLING_UNIT_IDENTIFIER_OPTIONS = [
  { value: "Bag(s)/Sack(s)", label: "Bag(s)/Sack(s)" },
  { value: "Barrel(s)/Drum(s)", label: "Barrel(s)/Drum(s)" },
  { value: "Bundle(s)", label: "Bundle(s)" },
  { value: "Carton(s)", label: "Carton(s)" },
  { value: "Case(s)/Crate(s)", label: "Case(s)/Crate(s)" },
  { value: "Package(s)", label: "Package(s)" },
  { value: "Pallet(s)", label: "Pallet(s)" },
  { value: "Rack(s)", label: "Rack(s)" },
  { value: "Reel(s)", label: "Reel(s)" },
  { value: "Unit(s)", label: "Unit(s)" },
];

export const WEIGHT_UNIT_TYPE_OPTIONS = [
  { value: "Kilogram(s)", label: "Kilogram(s)" },
  { value: "Metric Tonne(s)", label: "Metric Tonne(s)" },
  { value: "Pound(s)", label: "Pound(s)" },
];

export const SEAL_STATUS_OPTIONS = [
  { value: "145", label: "Broken" },
  { value: "146", label: "Replaced" },
  { value: "147", label: "No Seal" },
  { value: "148", label: "Intact" },
  { value: "149", label: "No Information" },
  { value: "150", label: "Extra Seal" },
];

export const TYPE_OF_CLAIM_OPTIONS = [
  { value: "140", label: "Reported Incident (LP ROC)" },
  { value: "141", label: "Investigated Incident (SIM)" },
];

export const CARRIER_TYPE_OPTIONS = [
  { value: "Strategic", label: "Strategic" },
  { value: "Non-Strategic", label: "Non-Strategic" },
  { value: "Chameleon Carrier", label: "Chameleon Carrier" },
  { value: "Rail", label: "Rail" },
  { value: "Relay", label: "Relay" },
  { value: "Sea", label: "Sea" },
  { value: "3P", label: "3P" },
  { value: "Other", label: "Other" },
];

export const TRANSPORTATION_MODE_OPTIONS = [
  { value: "136", label: "Middle Mile Linehaul" },
  { value: "137", label: "Middle Mile Intermodal" },
  { value: "138", label: "Middle Mile Sea" },
  { value: "139", label: "Inbound" },
];

export const TRAILER_TYPE_OPTIONS = [
  { value: "151", label: "Hard Sided" },
  { value: "152", label: "Soft Sided" },
  { value: "153", label: "Soft Roof" },
  { value: "154", label: "No Information" },
];
